import Backbone from 'backbone-lib';
import Cocktail from 'backbone.cocktail';

Cocktail.patch(Backbone);
export default Backbone;
